import React from "react";
import {
  useRetrieveCurrentPlanzone,
  useRetrieveDocuments,
} from "@planzone/view-models";
import { Identifiable, Document } from "@planzone/dto";
import { DocumentIcon } from "@common/documentIcon";
import { FolderIcon } from "@common/folderIcon";
import { useWorkspaceContext } from "@scenes/workspaceContext";
import { Props } from "./types";
import styles from "./styles.scss";
import { Skeleton } from "@common/skeleton";

function Loader(_: Props) {
  return (
    <div className={styles.loader}>
      <div className={styles.folder} style={{ paddingLeft: "1rem" }}>
        <Skeleton className={styles.folderIcon} />
        <Skeleton className={styles.name} />
      </div>
      <div className={styles.document} style={{ paddingLeft: "2rem" }}>
        <Skeleton className={styles.documentIcon} />
        <Skeleton className={styles.name} />
      </div>
      <div className={styles.document} style={{ paddingLeft: "2rem" }}>
        <Skeleton className={styles.documentIcon} />
        <Skeleton className={styles.name} />
      </div>
      <div className={styles.document} style={{ paddingLeft: "2rem" }}>
        <Skeleton className={styles.documentIcon} />
        <Skeleton className={styles.name} />
      </div>
    </div>
  );
}

export { Loader };
